export default {
  userManagement: 'User management', // settings
  groupManagement: 'Group management',
  orgManagement: 'Organization management',
  entityManagement: 'Entity management',
  transactionData: 'Transaction data',
  // apiSettings: 'API settings', // Might bring back in future - disabled temporarily
  taxCodes: 'Tax codes', // filing
  deadlines: 'Deadlines',
  // dataFormats: 'Data formats', // Might bring back in future - disabled temporarily
  supportingDocs: 'Supporting documents',
  submitFiling: 'Submit filing',
  filingsDue: 'Filings due',
  files: 'Files',
  fileVatReturns: 'File VAT returns',
  issues: 'Issues',
  draftReturns: 'Draft returns',
  filingApproval: 'Approval of filings',
  managePayments: 'Manage payments',
  vatRegInfo: 'VAT registration info',
} as const;

export const permissionBlockStructureType = {
  userManagement: {},
  entityManagement: [],
  groupManagement: [],
  orgManagement: [],
  apiSettings: [],
} as const;

export const permissionBlockKeyMap = {
  userManagement: 'general',
  groupManagement: 'account',
  orgManagement: 'organization',
  entityManagement: 'entity',
  apiSettings: 'entity',
  filingsDue: 'vat_number',
  draftReturns: 'vat_number',
  fileVatReturns: 'vat_number',
  filingApproval: 'vat_number',
  issues: 'vat_number',
  managePayments: 'vat_number',
  submitFiling: 'vat_number',
  supportingDocs: 'vat_number',
  taxCodes: 'vat_number',
  transactionData: 'vat_number',
  vatRegInfo: 'vat_number',
} as const;

export const permissionTypeKeyMap = {
  account: 'account',
  organization: 'organization',
  entity: 'entity',
  entityJurisdiction: 'entity_jurisdiction',
  vatNumber: 'vat_number',
  userManagement: 'user_management',
  groupManagement: 'group_management',
  orgManagement: 'org_management',
  entityManagement: 'entity_management',
  apiSettings: 'api_settings',
  filingsDue: 'filings_due',
  draftReturns: 'draft_returns',
  fileVatReturns: 'file_vat_returns',
  filingApproval: 'filing_approval',
  issues: 'issues',
  managePayments: 'manage_payments',
  submitFiling: 'submit_filing',
  supportingDocs: 'supporting_docs',
  taxCodes: 'tax_codes',
  transactionData: 'transaction_data',
  vatRegInfo: 'vat_reg_info',
} as const;

export const permissionLevels = {
  0: 'none',
  1: 'view',
  2: 'modify',
} as const;

/** Map of features for client side permission management */
export const features = {
  DELETE_VAT_RETURN: 'FILING_DELETE_VAT_RETURN',
  EDIT_BANK_DETAILS: 'EDIT_BANK_DETAILS',
  EDIT_COMPANY_PROFILE: 'EDIT_COMPANY_PROFILE',
  FILING_MARK_AS_FILED: 'FILING_MARK_AS_FILED',
  FILING_SEND_FOR_FILING: 'FILING_SEND_FOR_FILING',
  FILING_BYPASS_CLIENT_APPROVAL: 'FILING_BYPASS_CLIENT_APPROVAL',
} as const;
